import Spinner from "../../components/feature-items/spinner/Spinner";
import "./skeleton.scss";

export function AppShellSkeleton() {
  return (
    <div className="skeleton-body">
      <div className={`skeleton_structure-bar`}>
        <div className="skeleton_structure-bar-slider"></div>
      </div>
      <div className="skeleton-content">
        <Spinner></Spinner>
      </div>
      <div className={`skeleton_header`}>
        <div className="skeleton_header-wrapper">
          <div className="skeleton_icon"></div>
          <div className="skeleton_icon"></div>
          <div className="skeleton_icon bg_brown300"></div>
          <div className="skeleton_icon"></div>
          <div className="skeleton_icon"></div>
        </div>
      </div>
    </div>
  );
}
